import { computed, defineComponent } from 'vue'
import type { SlotsType, ExtractPropTypes, CSSProperties } from 'vue'
import { filterEmpty } from '../_antd_util'
import { withInstall } from '../_util'

export const spaceProps = () => ({
  gutter: [Boolean, String],
  vertical: [Boolean, String],
})

export type SpaceProps = Partial<ExtractPropTypes<ReturnType<typeof spaceProps>>>

const Space = defineComponent({
  name: 'OSpace',
  inheritAttrs: false,
  props: spaceProps(),
  slots: Object as SlotsType<{
    default?: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    const classes = computed(() => {
      const { vertical } = props

      return ['orion-space', { [`vertical`]: vertical === true || vertical === '' }]
    })

    return () => {
      const children = slots.default?.()
      const items = filterEmpty(children)
      const len = items.length

      if (len === 0) {
        return null
      }

      const gapStyle: CSSProperties = {}
      if (typeof props.gutter == 'string' && props.gutter) {
        gapStyle.gap = props.gutter
      }

      return (
        <div class={[classes.value, attrs.class]} style={[gapStyle, attrs.style as CSSProperties]}>
          {items.map((child) => {
            return <div class={['orion-space-item']}>{child}</div>
          })}
        </div>
      )
    }
  },
})

export default withInstall<typeof Space, {}>(Space, {})
